export default __webpack_public_path__ + "static/media/ReferralProgramIcon.d001e254.svg";